/**
 * @desc 加油站对账导出
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.ComeOnReconciliationQueryParameters): Promise<BaseResponse<any>> {
  return fetch({
    url: config.API_HOST + '/fuel/fee/exportStationReconciliation',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
